import { object, string } from 'yup';

export const validationSchema = object({
    country: string().required("Required"),
    province: string().when("country_code", (country_code, schema) => {
        if (country_code) {
            let restrictedCountryCodeList = ['US', 'CA']
            if (restrictedCountryCodeList.includes(country_code)) {
                return schema.required("This field is required")
            }
        }
        return schema
    })
});
